import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { Mail } from "lucide-react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { forgetPasswordValidationForm } from "../../utils/validationSchema";
import Button from "../Reusable/Button";
import TextField from "../Reusable/Form/TextInput";

const ForgetPassword = (props: any) => {
  const { handleSubmit, reset, control } = useForm<any>({
    resolver: yupResolver(forgetPasswordValidationForm),
  });

  const { handlePasswordReset } = props;

  return (
    <>
      <form
        onSubmit={handleSubmit((data) => handlePasswordReset(data, reset))}
        autoComplete="off"
      >
        <div className={tw`w-full`}>
          <TextField
            label={"Email"}
            icon={<Mail color="gray" strokeWidth={2} />}
            name="email"
            control={control}
          />
          <Button label={"Reset Password"} />
        </div>
      </form>
      <div className={tw`w-full text-right p-4`}>
        <Link to="/">Back To Login</Link>
      </div>
    </>
  );
};

export default ForgetPassword;
